import { useState, useRef, useEffect, useCallback } from "react";
const useInputValue = ({
  defaultValue,
  value,
  onChange,
  notNull: notNull_,
  required,
  emptyValue,
  extractValue,
  readOnly,
  disabled
}) => {
  const notNull = notNull_ || required;
  const emptyOrNull = notNull ? emptyValue : null;
  const [internalState, setInternalState] = useState((value !== void 0 ? value : defaultValue) ?? emptyOrNull);
  const onChangeRef = useRef(onChange);
  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);
  useEffect(() => {
    if (value === void 0) {
      return;
    }
    setInternalState(value ?? emptyOrNull);
  }, [emptyOrNull, emptyValue, notNull, value]);
  const onChangeListener = useCallback((event) => {
    const inputValue = extractValue(event.target);
    const normalizedValue = inputValue ?? (notNull ? emptyValue : null);
    if (inputValue === void 0 || emptyOrNull) {
      if (notNull && false) {
        console.error("Input value is null, but notNull is true");
      }
      return;
    }
    if (!readOnly && !disabled) {
      onChangeRef.current?.(normalizedValue);
      setInternalState(inputValue);
    }
  }, [extractValue, notNull, emptyValue, emptyOrNull, readOnly, disabled]);
  return {
    onChange: onChangeListener,
    state: internalState
  };
};
export {
  useInputValue
};
//# sourceMappingURL=useInputValue.js.map
